import { AppointmentType } from "@/constants/imbp"
import { getUserPermissions } from "@/services-handlers/getUserPermissions"

export type JobType = {
  selectedMeterTypeAes: string
  selectedInstallationType: string
  selectedAppointmentType: string
  isAllowedToBook: boolean
  errorMessage: ErrorType | null
}

type BookingPermission = {
  permission: string
  notAllowed: Array<string>
}

type AppointmentErrorType = {
  errorType: ErrorType | null
  appointments: Array<AppointmentType>
}

export type ErrorType = "exchange" | "repair" | "emergency"

export const checkBookingPermission = (selectedAppointmentType: string) => {
  const userBookingPermissions = bookingPermissions.filter(({ permission }) =>
    getUserPermissions.hasPermission(permission),
  )

  if (!userBookingPermissions.length)
    return {
      error: getErrorMessage(selectedAppointmentType),
      isAllowed: false,
    }

  const permissionMatchesJobType = userBookingPermissions.filter(
    (val) => !val.notAllowed.includes(selectedAppointmentType),
  )
  const isAllowed = permissionMatchesJobType.length > 0

  return {
    error: !isAllowed ? getErrorMessage(selectedAppointmentType) : null,
    isAllowed,
  }
}

const getErrorMessage = (appointmentType): ErrorType | null =>
  appointmentErrorList.filter((bucket) =>
    bucket.appointments.includes(appointmentType),
  )?.[0]?.errorType ?? null

const appointmentErrorList: Array<AppointmentErrorType> = [
  {
    errorType: "exchange",
    appointments: [AppointmentType.METER_EXCHANGE],
  },
  {
    errorType: "repair",
    appointments: [AppointmentType.INVESTIGATION],
  },
  {
    errorType: "emergency",
    appointments: [
      AppointmentType.EMERGENCY_FAULTS,
      AppointmentType.EMERGENCY_INVESTIGATION,
      AppointmentType.EMERGENCY_METER_EXCHANGE,
    ],
  },
]

const bookingPermissions: Array<BookingPermission> = [
  {
    permission: "agent.imbpBookBasicJobs",
    notAllowed: [
      AppointmentType.EMERGENCY_FAULTS,
      AppointmentType.EMERGENCY_INVESTIGATION,
      AppointmentType.EMERGENCY_METER_EXCHANGE,
      AppointmentType.INVESTIGATION,
      AppointmentType.METER_EXCHANGE,
    ],
  },
  {
    permission: "agent.imbpBookInvestigatoryJobs",
    notAllowed: [
      AppointmentType.EMERGENCY_FAULTS,
      AppointmentType.EMERGENCY_INVESTIGATION,
      AppointmentType.EMERGENCY_METER_EXCHANGE,
    ],
  },
  {
    permission: "agent.imbpBookEmergencyJobs",
    notAllowed: [],
  },
]
